import challengeIllustration from 'assets/images/monthlyReport/challengeIllustration.png';
import React, { FC, memo } from 'react';
import SectionHeading from '../SectionHeading';
import {
  Body,
  BoldLine,
  ButtonArrow,
  Card,
  ChallengeButton,
  Container,
  Illustration,
  Paragraph,
} from './styles';
import { Props } from './types';

const Challenge: FC<Props> = ({ challenge, periodLabel }) => {
  if (!challenge) {
    return null;
  }

  const month = periodLabel.split(' ')[0];

  return (
    <Container>
      <SectionHeading title="The SWD challenge" />
      <Card>
        <Illustration
          src={challenge.image || challengeIllustration}
          alt={challenge.title}
        />
        <Body>
          {challenge.submitted ? (
            <>
              <BoldLine>
                Congratulations, you completed the {month} challenge!
              </BoldLine>
              <Paragraph>
                Take a look at how other members have approached{' '}
                {challenge.title} for a dose of inspiration and feel free to
                provide kudos and comments.
              </Paragraph>
            </>
          ) : (
            <Paragraph>
              You didn&#8217;t get to last month&#8217;s challenge&#8212;no
              worries! Take a look at how other members have approached{' '}
              {challenge.title} for a dose of inspiration, and feel free to
              provide kudos and comments. We&#8217;d love to see what you share
              for this month&#8217;s challenge, if you haven&#8217;t already.
            </Paragraph>
          )}
          <ChallengeButton variant="secondary" mode="small" to={challenge.url}>
            View submissions
            <ButtonArrow />
          </ChallengeButton>
        </Body>
      </Card>
    </Container>
  );
};

export default memo(Challenge);
